class DateTacke{
    constructor(brtacke, y, x, data, index){
        this.brtacke=brtacke;
        this.y = y;
        this.x = x;
        this.data = data;
        this.index = index;
    }
}

export {DateTacke as default}
